import { toast as sonnerToast } from 'sonner';

const toast = Object.assign(
  (...args: Parameters<typeof sonnerToast>) => sonnerToast(...args),
  sonnerToast
) as typeof sonnerToast;

toast.success = (..._args) => '' as string | number;
toast.info = (..._args) => '' as string | number;

export { toast };
